<template>
  <div>
    <task-filter @change="onChange" />
    <br />
    <task-delivery-alone-rate :filter-form="filterForm" height="360px" />
    <br />
    <!-- <task-derivative :filter-form="filterForm" height="360px" />
    <br /> -->
    <task-point-rank :filter-form="filterForm" height="360px" />
    <br />
    <task-point-average :filter-form="filterForm" height="360px" />
    <br />
    <task-take-time-distribution :filter-form="filterForm" height="360px" />

    <br />
    <TaskPointOverTime :filter-form="filterForm" />
    <br />
    <task-created-deleted-trend :filter-form="filterForm" height="360px" />
    <br />
    <TaskDely v-if="false" :filter-form="filterForm" height="360px" width="100%" />
  </div>
</template>
<script>
import TaskFilter from '@/pages/data/task/components/TaskFilter';
import TaskPointRank from '@/pages/data/task/components/TaskPointRank';
import TaskPointAverage from '@/pages/data/task/components/TaskPointAverage';
import TaskDeliveryAloneRate from '@/pages/data/task/components/TaskDeliveryAloneRate';
import TaskDerivative from '@/pages/data/task/components/TaskDerivative';
import TaskPointOverTime from '@/pages/data/task/components/TaskPointOverTime';
import TaskCreatedDeletedTrend from '@/pages/data/task/components/TaskCreatedDeletedTrend';
import TaskTakeTimeDistribution from '@/pages/data/task/components/TaskTakeTimeDistribution';
// import TaskDely from '@/pages/data/task/components/TaskDely';

export default {
  components: { TaskFilter, TaskPointRank, TaskPointAverage, TaskDeliveryAloneRate, TaskCreatedDeletedTrend, TaskPointOverTime, TaskTakeTimeDistribution, TaskDerivative },
  data() {
    return {
      filterForm: {
        begin_date: null,
        end_date: null
      }
    };
  },
  methods: {
    onChange(checkedDate, checkedTeams) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        teams: checkedTeams
      };
    }
  }
};
</script>
